<template>
    <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
        <g fill="#48B6E7" fill-rule="nonzero">
            <path
                d="M16.232.039H2.029A2.035 2.035 0 0 0 0 2.068v14.203C0 17.387.913 18.3 2.029 18.3h7.71c-.609-.609-1.014-1.319-1.319-2.03H2.03V6.127h14.203v2.232c.71.304 1.42.811 2.029 1.319V2.068A2.035 2.035 0 0 0 16.23.039zM3.043 4.097c-.608 0-1.014-.406-1.014-1.015 0-.608.406-1.014 1.014-1.014.508 0 1.015.406 1.015 1.014 0 .61-.507 1.015-1.015 1.015zm3.551 0c-.608 0-1.014-.406-1.014-1.015 0-.608.406-1.014 1.014-1.014.507 0 1.015.406 1.015 1.014 0 .61-.508 1.015-1.015 1.015z"
            />
            <path
                d="M19.705 18.203l-2.553-2.551c.51-.816.715-1.837.51-2.857-.306-1.632-1.736-2.959-3.472-3.163-2.656-.306-4.903 1.939-4.597 4.591.205 1.633 1.532 3.061 3.167 3.47 1.021.203 2.042 0 2.86-.51l2.553 2.55a.988.988 0 0 0 1.43 0c.51-.51.51-1.122.102-1.53z"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "Operating",
};
</script>
